import { SET_STRIPELINKTODRIVER } from '../actions';

const driverstripelink = (state = [], action) => {
  switch (action.type) {
	case SET_STRIPELINKTODRIVER:
      return [...action.value];  
    default: return state;
  }
}

export default driverstripelink;
